import React, { useState, useEffect } from 'react';
import { Label, Button, Input } from 'reactstrap';

const PatientModal = ({
  isOpen,
  onClose,
  onSave,
  isEditMode = false,
  patient = null,
}) => {
  // Default Date of Birth to ComprehendPT's birthday for the case where they don't know the bDay
  const DEFAULT_DOB = '2023-05-29';
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState(DEFAULT_DOB);

  useEffect(() => {
    // Populate the input fields with initial user data when in Edit mode
    if (isEditMode && patient) {
      setFirstName(patient.firstName || '');
      setLastName(patient.lastName || '');
      setDob(formatDate(patient.dob) || DEFAULT_DOB);
    }
  }, [isEditMode, patient]);

  if (!isOpen) return null;

  const handleSave = () => {
    // Validate the input fields, perform any necessary validation here
    if (!firstName || !lastName || !dob) {
      alert('Please fill in all fields.');
      return;
    }

    // Call the onSave function with the entered values
    onSave(firstName, lastName, dob);

    // Clear the input fields when we make a new patient (If we were in the patient details and
    // clicked "New Patient" then clicked new patient again, this was not being reset)
    if (!isEditMode) {
      setFirstName('');
      setLastName('');
      setDob(DEFAULT_DOB);
    }

    // Close the modal
    onClose();
  };

  function formatDate(dateString) {
    // Split the date string into components
    var parts = dateString.split('/');
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10) - 1; // JavaScript months are 0-based
    var year = parseInt(parts[2], 10);

    // Create a new Date object
    var date = new Date(year, month, day);

    // Check if the date is valid
    if (date == 'Invalid Date') {
      return null;
    }

    // Format the date to YYYY-MM-DD
    var formattedDate = date.toISOString().split('T')[0];

    return formattedDate;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="mb-4">Enter Patient Information</h2>
        <div className="form-group">
          <Label for="firstName">First Name:</Label>
          <Input
            id="firstName"
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)} // Update state when input changes
          />
        </div>
        <div className="form-group">
          <Label for="lastName">Last Name:</Label>
          <Input
            id="lastName"
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)} // Update state when input changes
          />
        </div>
        <div className="form-group">
          <Label for="dob">Date of Birth:</Label>
          <Input
            id="dob"
            type="date"
            value={dob}
            onChange={(e) => setDob(e.target.value)} // Update state when input changes
          />
        </div>
        <div className="modal-buttons">
          <Button color="primary" onClick={handleSave}>
            Save
          </Button>
          <Button color="danger" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PatientModal;
